import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import { saveLoaderCompleted, saveLoaderProgress, showMessage } from "../../messages/messagesActions";
import { IComplianceFiles, ILifeInsurancePolcyComplianceCheckList } from "./lifeInsurancePolicyComplianceCheckList.types";
import { uploadFile } from "../../../features/FileUpload/utils";

export const FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_PROGRESS =
  "FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_PROGRESS";
export const FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_SUCCESS =
  "FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_SUCCESS";
export const FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_FAILED =
  "FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_FAILED";

export const fetchLifeInsuranceComplianceCheckListProgress = () =>
  action(FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_PROGRESS);
export const fetchLifeInsuranceComplianceCheckListSuccess = (
  data: ILifeInsurancePolcyComplianceCheckList
) => action(FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_SUCCESS, { data });
export const fetchLifeInsuranceComplianceCheckListFailed = (
  errorMessage: string
) => action(FETCH_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_FAILED, { errorMessage });

export const fetchLifeInsuranceComplianceCheckListAsync =
  (customerPolicyId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLifeInsuranceComplianceCheckListProgress());
      const res = await api.get(
        `/policy/get-life-policy-compliance-checklist?customer_policy_id=${customerPolicyId}`
      );
      const data: ILifeInsurancePolcyComplianceCheckList[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchLifeInsuranceComplianceCheckListSuccess(data[0]));
      } else {
        dispatch(
          fetchLifeInsuranceComplianceCheckListFailed(
            "Oops! We couldn't find any records associated with your restrutant number at the moment. Please ensure that the provided information is accurate and try again."
          )
        );
        //   }
      }
    } catch (err: any) {
      dispatch(
        fetchLifeInsuranceComplianceCheckListFailed(
          "Something went to be wrong!"
        )
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addLifeInsuranceComplianceCheckListAsync =
  (
    data: ILifeInsurancePolcyComplianceCheckList,
    files: IComplianceFiles,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress())
      const asPayload = {
        customer_id: data.customer_id,
        customer_policy_id: data.customer_policy_id,
      };
      const advisorDisclosureFile = await uploadFile(
        files.advisor_disclosure_file,
        "LIFE_FINANCE",
        data.advisor_disclosure_file || "",
        asPayload
      );
      const kycInsuranceNeedsFinancialNeedsAnalysisFile = await uploadFile(
        files.kyc_insurance_needs_financial_needs_analysis_file,
        "LIFE_FINANCE",
        data.kyc_insurance_needs_financial_needs_analysis_file || "",
        asPayload
      );
      const privacyStatementFile = await uploadFile(
        files.privacy_statement_file,
        "LIFE_FINANCE",
        data.privacy_statement_file || "",
        asPayload
      );
      const lirdFile = await uploadFile(
        files.lird_file,
        "LIFE_FINANCE",
        data.lird_file || "",
        asPayload
      );
      const investorProfileFile = await uploadFile(
        files.investor_profile_file,
        "LIFE_FINANCE",
        data.investor_profile_file || "",
        asPayload
      );
      const overallProductSuitabilityFile = await uploadFile(
        files.overall_product_suitability_file,
        "LIFE_FINANCE",
        data.overall_product_suitability_file || "",
        asPayload
      );
      const notesFile = await uploadFile(
        files.notes_file,
        "LIFE_FINANCE",
        data.notes_file || "",
        asPayload
      );
      const complianceStatusFile = await uploadFile(
        files.compliance_status_file,
        "LIFE_FINANCE",
        data.compliance_status_file || "",
        asPayload
      );
      const consentFile = await uploadFile(
        files.consent_file,
        "LIFE_FINANCE",
        data.consent_file || "",
        asPayload
      );
      await api.post(`/policy/edit-life-policy-compliance-checklist`, {
        ...data,
        advisor_disclosure_file: advisorDisclosureFile,
        kyc_insurance_needs_financial_needs_analysis_file: kycInsuranceNeedsFinancialNeedsAnalysisFile,
        privacy_statement_file: privacyStatementFile,
        lird_file: lirdFile,
        investor_profile_file: investorProfileFile,
        overall_product_suitability_file: overallProductSuitabilityFile,
        notes_file: notesFile,
        compliance_status_file: complianceStatusFile,
        consent_file: consentFile,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Compliance Checklist saved successfully!",
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
      onCallback(false);
    } finally {
      dispatch(saveLoaderCompleted())
    }
  };

export const CLEAR_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_STATE =
  "CLEAR_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_STATE";
export const CLEAR_LIFE_INSURANCE_COMPLIANCE_CHECKLIST =
  "CLEAR_LIFE_INSURANCE_COMPLIANCE_CHECKLIST";

export const clearLifeInsuranceCOMPLIANCECheckListState = () =>
  action(CLEAR_LIFE_INSURANCE_COMPLIANCE_CHECKLIST_STATE);

export const cleaLifeInsuranceCOMPLIANCECheckList = () =>
  action(CLEAR_LIFE_INSURANCE_COMPLIANCE_CHECKLIST);

// /policy/edit-life-policy-compliance-checklist
// /policy/get-life-policy-compliance-checklist
